export default __webpack_public_path__ + "static/media/2.c0da7eec.svg";